import { Component, OnInit } from '@angular/core';
import { InvoiceService } from 'src/app/services/http/business/invoice/invoice.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-paymnet-confirmation',
  templateUrl: './paymnet-confirmation.component.html',
  styleUrls: ['./paymnet-confirmation.component.css']
})
export class PaymnetConfirmationComponent implements OnInit {
  response: any;
  isDevice = false;
  constructor(private route: ActivatedRoute,
    private invoiceService: InvoiceService) { }

  ngOnInit() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isDevice = true;
    }
    else {
      this.isDevice = false;
    }
    this.checkPayment();
  }
  checkPayment() {
    this.route.paramMap.subscribe(params => {
      //this.response = params.get('InvoiceOnlinePaymentId');
      this.invoiceService.paymnetConfirmation(params.get('InvoiceOnlinePaymentId')).subscribe(res => {
        console.log(res);

        this.response = res;
      });
    });
  }

  PrintElem() {
    window.print();
  }
  return() {
    //window.close();
    self.close()
    window.close()
    // if(this.response.PayPersonName)
    // {
    //   //پرداخت توسط دیگران

    // }
    // else{
    //   //پرداخت توسط خود شخص
    // }
  }

}
